import React, { memo } from 'react';
import { ScrollView } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { LoadingContainer } from '@redlink/components/atoms';
import { PreviewLinksList } from '@redlink/components/muscles';
import {
  PreviewUserProfileInfo,
  PoweredByLogo,
} from '@redlink/components/molecules';
import {
  useQuery,
  getPagePreviewProfileQuery,
  getPagePreviewLinkQuery,
} from '@redlink/services';

export const PreviewBasicProfilePage = memo(({ pageName }) => {
  const { styles } = useStyle();

  const {
    loading: getPagePreviewProfileIsBusy,
    data: {
      PageProfilePreview: {
        fullname,
        emailAddress,
        avatar,
        bio,
        cellphoneNumber,
      } = {},
    },
  } = useQuery(getPagePreviewProfileQuery, { variables: { pageName } });

  const {
    loading: getPagePreviewLinkIsBusy,
    data: { LinksPreview },
  } = useQuery(getPagePreviewLinkQuery, { variables: { pageName } });

  return (
    <LoadingContainer
      isInitial
      hasOverlay={false}
      isBusy={getPagePreviewProfileIsBusy || getPagePreviewLinkIsBusy}
      style={styles.container}
    >
      <ScrollView
        style={styles.scrollContainer}
        showsVerticalScrollIndicator={false}
      >
        <PreviewUserProfileInfo
          isCompact
          imageUrl={avatar?.thumbnailUrl}
          title={fullname}
          subtitle={bio}
          emailAddress={emailAddress}
          cellPhone={cellphoneNumber}
          style={styles.bodyContainer}
        />
        <PreviewLinksList data={LinksPreview} />
        <PoweredByLogo />
      </ScrollView>
    </LoadingContainer>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  bodyContainer: {
    paddingTop: 72,
    paddingBottom: 20,
    paddingHorizontal: 24,
  },
  scrollContainer: {
    paddingBottom: 60,
  },
}));
